import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface UseNavigationTransitionOptions {
  transitionDuration?: number;
  onTransitionStart?: () => void;
  onTransitionEnd?: () => void;
}

export const useNavigationTransition = (options: UseNavigationTransitionOptions = {}) => {
  const { transitionDuration = 200, onTransitionStart, onTransitionEnd } = options;
  const location = useLocation();
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [currentPath, setCurrentPath] = useState(location.pathname);

  useEffect(() => {
    if (location.pathname !== currentPath) {
      setIsTransitioning(true);
      onTransitionStart?.();
      setCurrentPath(location.pathname);
      const timer = setTimeout(() => {
        setIsTransitioning(false);
        onTransitionEnd?.();
      }, transitionDuration);

      return () => clearTimeout(timer);
    }
  }, [location.pathname, currentPath, transitionDuration, onTransitionStart, onTransitionEnd]);

  const getPageWrapperClasses = () => {
    return `page-wrapper ${isTransitioning ? 'transitioning' : ''}`;
  };

  const getPageContentClasses = () => {
    return `page-content ${isTransitioning ? 'fade-out' : 'fade-in'}`;
  };

  return {
    isTransitioning,
    currentPath,
    getPageWrapperClasses,
    getPageContentClasses
  };
}; 